import React, { useEffect, useState } from 'react'
import useDisplayTime from '../../hooks/useDisplayTime';

export default function EjectCountdown({seconds, onTimesUp}) {
  console.log('[EjectCountdown] [seconds: %s]', seconds);
  
  const {asDigitalWatch} = useDisplayTime();
  const [counter, setCounter] = useState('--:--');
  
  //---[  Effect  ]---
  //
  useEffect(()=>{
    const startTime = Date.now();
    const targetTime = startTime + (seconds * 1000);

    const intervalId = setInterval(()=>{
      const timeLeft = targetTime - Date.now();
      if (timeLeft < 0.1) {
        clearInterval(intervalId);
        onTimesUp();
      }
      setCounter(asDigitalWatch(timeLeft));
    }, 1000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    }
  }, [asDigitalWatch, onTimesUp, seconds]);
  

  //---  Render ---

  return (
    <div>Auto-Logout in {counter}</div>
  )
}
